module.exports = __webpack_public_path__ + "media/images/Icon-ticket-26b6b92fcfbfff49797e101a538f5000.svg";